import React, { useEffect, useState } from "react";
import { Card, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
//import Waiverdocs from './Waiverdocs';

type Props = {
    updateWaiverDocs:Function,
}

const Waiver = (props: Props) => {
   
    const { data ,index,updateWaiverDocs} = props;
    const [storageInitialized, setIsStorageInitialized] = useState(false);

   
   console.log(data)

  const cardStyle = {
    borderRadius: '10px', 
    width: '100%', 
    marginTop: '20px',
    border: '1px solid rgba(0, 0, 0, 0.2)',
    
  };

  const paragraphStyle = {
    padding: '10px',
    margin: '0',
    fontWeight: '550',
  };

  const headingStyle = {
    fontWeight: 'bold',
    padding: '10px',
    margin: '0'
  };


  useEffect(() => {
   
    if (data.documentUrl==="")
    {
        setIsStorageInitialized(true);
    }
    const checkStorage = () => {
        const wData = localStorage.getItem('waiverDocApproved');
        if (wData === 'true') {
            setIsStorageInitialized(true);
            localStorage.removeItem('waiverDocApproved');
            updateWaiverDocs(index)
        } else {
            //alert("hello")
            setTimeout(checkStorage, 1000); // Check every second
           
        }
    };

    checkStorage(); // Initial check when component mounts

    // Clean up function
    return () => {
        clearTimeout(checkStorage);
    };
}, []); // Empty dependency array to run effect only once on mount


  const iconStyle = {
    marginRight: '8px', 
    color: 'green',

  }
  

  const handleButtonClick = () => {
   
    console.log('Button clicked!'+data.documentUrl);

    const encryptedParam = btoa(data.documentUrl);
    
    window.open(`/Waiverdocs/${encryptedParam}`, '_blank');
    
  };

  const buttonContainerStyle = {
    display: 'flex',
    justifyContent: 'center', 
    marginTop: '20px', 
  };

  const buttonStyle = {
    borderRadius: '4px',
    backgroundColor: 'white',
    color: 'black',
    border: '2px solid rgb(86,153,255)',
    padding: '8px 70px', 
    whiteSpace: 'normal', 
    wordBreak: 'break-word', 
    textAlign: 'center' 
  };

  return (
    
    <div style={{ display: 'flex', justifyContent: 'center' }}>
        
      <Card style={cardStyle} bordered={false}>
        <h2 style={headingStyle}>{data.label}</h2>
        <p style={paragraphStyle}>
         {data.description}
        </p>
        <div style={buttonContainerStyle}>
          <Button style={buttonStyle} onClick={handleButtonClick}  disabled={(storageInitialized )}>
          Click to view the document 
         
             &nbsp;{storageInitialized ? <CheckCircleOutlined style={iconStyle} /> :"" }
          </Button>
        
        </div><br></br>
       {data.showError===true ? 
        <p style={{
                      fontSize: '12px',
                      color: '#ff1e1e',
                      fontWeight: '550',
                      marginBottom: '20px',
                      padding: '10px'
                    }}>View document to accept consent form</p> 
            :null     }
               
      </Card>
    
    </div>
  );
};

export default Waiver;
